<template>
    <b-form @submit="onSubmit" autocomplete="off" class="form-horizontal">
        <!-- Page title -->
        <b-row>
            <b-col lg="6">
                <h3 class="text-themecolor">{{$t('sidebar.urenexport')}}</h3>
            </b-col>
        </b-row>
        <!-- Page title -->
        
        <!-- Form content -->
        <b-row>
            <b-col lg="6">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">{{$t('exporthours.tijdsbestek')}}</h4>
                        
                        <b-form-group label-cols :label="$t('exporthours.startdatum')">
                            <datepicker class="form-control" v-model="command.startDate" placeholder="dd-mm-yyyy" />
                        </b-form-group>

                        <b-form-group label-cols :label="$t('exporthours.einddatum')">
                            <datepicker class="form-control"  v-model="command.endDate" placeholder="dd-mm-yyyy"/>
                        </b-form-group>
                                                
                    </div>
                </div>
            </b-col>
        </b-row>
        <!-- Form content -->

        <!-- Submit controls -->
        <b-row>
            <b-col lg="6">
                <b-button type="submit" class="pull-right" variant="themecolor">{{$t('buttons.exporteren')}}</b-button>
            </b-col>
        </b-row>
        <!-- Submit controls -->
    </b-form>
</template>
<script>
    //Import store
    import {mapActions} from 'vuex';
    import Command from "./command";

    export default {
        name: `export-times-index`,
        data() {
            return {
                command: new Command()
            };
        },
        methods: {
            ...mapActions('comceptum',['downloadExport']),
            onSubmit(event) {
                event.preventDefault();

                let vm = this;
                vm.downloadExport({
                    startDate: vm.$options.filters.formatDateTime(vm.command.startDate,"YYYY-MM-DD"),
                    endDate: vm.$options.filters.formatDateTime(vm.command.endDate,"YYYY-MM-DD")
                }).then(()=> {
                    vm.command = new Command();
                });
            },
        }
    };
</script>
